import { compose } from 'redux';
import { connect } from 'react-redux';
import ExposeLifecycle from 'rlink-expose-lifecycle';
import CareersPanel from '../CareersPanel';

function mapStateToProps ({caches}) {
  return {
  };
}

function mapDispatchToProps (dispatch) {
  return {
    onPropsChange () {
    },
  };
}

let connected = compose(
  connect(mapStateToProps, mapDispatchToProps),
  ExposeLifecycle
)(CareersPanel);

export default connected;



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/connected/CareersPanel.jsx